<template>
    <div class="container">
        <div class="d-flex justify-content-center align-items-center"> 
            <img src="../../dist/logo.png" class="img-fluid w-25">
        </div>
        <!-- <h3 class="text-center text-bold mt-2">Login Page</h3> -->
        <div class="d-flex justify-content-center">
            <div class="alert alert-danger alert-dismissible fade show w-50" v-show="alert">
                <strong>{{message}}</strong>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <form class="w-50" @submit.prevent="login()">
                <div class="from-group">
                    <label><i class="fas fa-user-shield text-success"></i> Username:</label>
                    <input type="text" v-model="formLogin.username" class="form-control" placeholder="Enter Username">
                </div>
                <div class="from-group">
                    <label><i class="fas fa-user-lock text-danger"></i> Password:</label>
                    <input type="password" v-model="formLogin.password" class="form-control" placeholder="Enter Password">
                </div><hr>
                <div class="d-flex">
                    <div class="col-6">
                        <button class="btn btn-primary btn-block text-bold">Sing In <i class="fas fa-sign-in-alt"></i></button>
                    </div>
                    <div class="col-6">
                        <router-link class="btn btn-success btn-block text-bold" to="/">Go Home <i class="fas fa-home"></i></router-link>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            alert:false,
            message:'',
            formLogin: new Form({
                username:'',
                password:'',
            })
        }
    },
    beforeCreate(){
        this.$parent.checkAfterLogin() 
    },
    methods: {
        login(){
            this.formLogin.post('http://pgm01.toonjob.com/2019/BannKlong/project/actionLogin')
            .then((response) => {
                if(response.data.login === 0){
                    this.alert = true
                    this.message = response.data.message
                }else{
                    this.$session.set('keyid', response.data.keyid)
                    this.$session.set('keyserial', response.data.keyserial)
                    this.$session.set('keytoken', response.data.keytoken)
                    window.location.href = '/pageHome'
                }
            })
        },
    },
    created() {
        
    }
}
</script>


// WEBPACK FOOTER //
// src/backEnd/LoginPage.vue